import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'confirm-modal',
    template: `
    <div class="novoLayout">
      <button type="button" class="btn-close-modal p-3" aria-label="Close" (click)="activeModal.dismiss()">
      <i class="centericon-retirar_permissao"></i>
      </button>

      <div class="modal-header py-3 px-0 novoLayout mx48 mt32">
        <h4 class="titulo-32 mb-0">{{title}}</h4>
      </div>
    </div>

    <div class="modal-body py-4 novoLayout mx48 px-0">
      <p class="mb-0" [innerHTML]="description"></p>
    </div>

    <div *ngIf="!isButtonOk && !danger" class="modal-footer pt-3 px-0 novoLayout mx48 mb56 pb-0">
      <button type="button" class="btn btn-primary btn-raised btn-dss-save" (click)="activeModal.close()">
        {{ labelButtonOk }}
      </button>
      <button type="button" class="btn btn-secondary btn-raised ml8i btn-dss-default" (click)="activeModal.dismiss()">
        {{ labelButtonCancel }}
      </button>
    </div>
    <div *ngIf="!isButtonOk && danger" class="modal-footer pt-3 px-0 novoLayout mx48 mb56 pb-0">
      <button type="button" class="btn btn-secondary btn-raised btn-dss-default" (click)="activeModal.dismiss()">
        {{ labelButtonCancel }}
      </button>
      <button type="button" class="btn btn-raised ml8i btn-excluir-danger" (click)="activeModal.close()">
        {{ labelButtonOk }}
      </button>
    </div>
    <div *ngIf="isButtonOk" class="modal-footer pt-3 px-0 novoLayout mx48 mb56 pb-0">
      <button type="button" class="btn btn-primary btn-raised btn-dss-save" (click)="activeModal.close()">OK</button>
    </div>
  `,
  standalone:true,
  imports:[CommonModule, TranslateModule, FormsModule]
})
export class ConfirmModal implements OnInit{

    @Input() title;
    @Input() description;
    @Input() isButtonOk = false;
    @Input() danger = false;
    @Input() labelButtonOk = this.translate.instant('Sim');
    @Input() labelButtonCancel = this.translate.instant('Não');

    constructor(public activeModal: NgbActiveModal, public translate: TranslateService) { }

    ngOnInit() {
      this.title = this.title ? this.title : this.translate.instant('Confirmação!');
      this.description = this.description ? this.description : this.translate.instant('Confirmar exclusão?');
    }

}
